<script setup lang="ts">
defineProps<{
  direction: 'horizontal' | 'vertical'
  dragging: boolean
}>()
</script>

<template>
  <div
    :class="[
      'shrink-0 relative z-10 transition-colors',
      direction === 'horizontal'
        ? 'w-[5px] cursor-col-resize'
        : 'h-[5px] cursor-row-resize',
      dragging ? 'bg-blue-400' : 'bg-neutral-200 hover:bg-blue-400',
    ]"
  />
</template>
